module.exports = __webpack_public_path__ + "img/keepy_uppy.c373f855.svg";